import React from 'react';
import { MailIcon, MessageCircleIcon, CheckIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-deep-cocoa text-white py-16" data-id="element-355">
      <div className="container-premium" data-id="element-356">
        {/* Final CTA */}
        <div className="text-center mb-12 pb-12 border-b border-white/10" data-id="element-357">
          <h3 className="text-2xl sm:text-3xl font-black mb-4" data-id="element-358">
            ¿Lista para cambiar tu situación?
          </h3>
          <p className="text-white/80 mb-6 max-w-2xl mx-auto" data-id="element-359">
            Únete a las 2,347 mujeres que ya generan ingresos desde casa
          </p>
          <a href="https://buy.stripe.com/dRm28rgfodEa83g1X618c00" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-cta-primary to-cta-secondary text-white font-bold rounded-xl shadow-glow-orange hover:shadow-xl hover:scale-105 transition-all duration-300" data-id="element-360">
            Obtener Mi Guía ($190 MXN)
          </a>
          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-white/60 mt-4" data-id="element-361">
            <span className="flex items-center gap-1.5" data-id="element-362">
              <CheckIcon className="w-4 h-4" data-id="element-363" />
              Garantía 30 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-364">
              <CheckIcon className="w-4 h-4" data-id="element-365" />
              Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-366">
              <CheckIcon className="w-4 h-4" data-id="element-367" />
              Pago único
            </span>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-368">
          {/* Brand */}
          <div className="sm:col-span-2" data-id="element-369">
            <h3 className="text-xl font-bold mb-4" data-id="element-370">Gana500TikTokShop</h3>
            <p className="text-white/70 text-sm leading-relaxed mb-4" data-id="element-371">
              Sistema completo para mujeres mexicanas que quieren generar
              $500-$2,000 MXN extra cada semana con TikTok Shop.
            </p>
          </div>

          {/* Links */}
          <div data-id="element-372">
            <h4 className="font-bold mb-4" data-id="element-373">Enlaces</h4>
            <ul className="space-y-2 text-sm" data-id="element-374">
              <li data-id="element-375">
                <a href="#features" className="text-white/70 hover:text-white transition-colors" data-id="element-376">
                  ¿Por qué funciona?
                </a>
              </li>
              <li data-id="element-377">
                <a href="#testimonials" className="text-white/70 hover:text-white transition-colors" data-id="element-378">
                  Resultados reales
                </a>
              </li>
              <li data-id="element-379">
                <a href="#faq" className="text-white/70 hover:text-white transition-colors" data-id="element-380">
                  Preguntas
                </a>
              </li>
              <li data-id="element-381">
                <a href="#checkout" className="text-white/70 hover:text-white transition-colors" data-id="element-382">
                  Comprar
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-383">
            <h4 className="font-bold mb-4" data-id="element-384">Soporte</h4>
            <div className="space-y-3 text-sm" data-id="element-385">
              <a href="mailto:soporte@gana500tiktokshop.com" className="flex items-center gap-2 text-white/70 hover:text-white transition-colors" data-id="element-386">
                <MailIcon className="w-4 h-4 flex-shrink-0" data-id="element-387" />
                <span data-id="element-388">soporte@gana500tiktokshop.com</span>
              </a>
              <a href="https://wa.me/525512345678" className="flex items-center gap-2 text-white/70 hover:text-white transition-colors" data-id="element-389">
                <MessageCircleIcon className="w-4 h-4 flex-shrink-0" data-id="element-390" />
                <span data-id="element-391">WhatsApp</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/10" data-id="element-392">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-white/60" data-id="element-393">
            <p data-id="element-394">© 2024 Gana500TikTokShop. Todos los derechos reservados.</p>
            <div className="flex gap-6" data-id="element-395">
              <a href="/privacy" className="hover:text-white transition-colors" data-id="element-396">
                Privacidad
              </a>
              <a href="/terms" className="hover:text-white transition-colors" data-id="element-397">
                Términos
              </a>
              <a href="/refund" className="hover:text-white transition-colors" data-id="element-398">
                Reembolsos
              </a>
            </div>
          </div>
          <p className="text-xs text-white/40 text-center mt-6" data-id="element-399">
            Los resultados individuales pueden variar. Esta guía proporciona
            información educativa. No garantizamos ingresos específicos.
          </p>
        </div>
      </div>
    </footer>;
}